'use client';
import { useCallback } from 'react';
import type { ElasticBranding } from '@//app/api/search/brandings';
import type { ElasticVehicle } from '@//app/api/search/vehicles/[id]';
import { Link } from '@//components/Link';
import { useLegacyTrackPaymentOptionClick } from '@//data/tracking/useLegacyTrackPaymentOptionClick';
import { useTriggerOnce } from '@//hooks/useTriggerOnce';

interface CreditCardProps {
  creditCard: ElasticBranding;
  vehicle: ElasticVehicle;
}

const CreditCardLink = ({ creditCard, vehicle }: CreditCardProps) => {
  const { trackLegacyPaymentOptionClick } = useLegacyTrackPaymentOptionClick();

  const trackLegacyPaymentOptionClickOnce = useTriggerOnce(
    (c: ElasticBranding, v: ElasticVehicle) =>
      trackLegacyPaymentOptionClick({
        vehicle: v,
        information: {
          paymentOptionName: c.name,
        },
      }),
  );

  const onClick = useCallback(
    () => trackLegacyPaymentOptionClickOnce(creditCard, vehicle),
    [creditCard, vehicle, trackLegacyPaymentOptionClickOnce],
  );

  if (!creditCard.website) return null;
  return (
    <Link
      href={creditCard.website}
      target="_blank"
      rel="noopener noreferrer nofollow"
      onClick={onClick}
    >
      Ansök om kort
    </Link>
  );
};

export default CreditCardLink;
